import withPage from '@lib/page';
import OrderCheckingPage from '@views/pages/order-checking';

export default withPage(OrderCheckingPage);